import React from 'react'
import { Loader } from 'stylist'
import styled from '@emotion/styled'
import { flexCenterContent, fixFill } from 'styles/positioning'

const LoadingContainer = styled.div`
  ${fixFill};
  ${flexCenterContent};
`

const PageLoader = () => (
  <LoadingContainer data-testid="loading-container">
    <Loader />
  </LoadingContainer>
)

export default PageLoader



// WEBPACK FOOTER //
// ./src/components/PageLoader.js